import { React, PT, WithData } from '@gasbuddy/react';
import { Dropdown, Grid, Button } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';
import { Report } from '../../components/report';

const ReportDropdown = ({ data, defaultValue, onChange }) => (
  <Dropdown
    search
    fluid
    selection
    loading={!data}
    placeholder="Select report..."
    onChange={onChange}
    defaultValue={defaultValue}
    options={data.map(o => ({
      text: o.name,
      value: o.id,
    }))}
  />
);

ReportDropdown.propTypes = {
  defaultValue: PT.string,
  data: PT.arrayOf({ name: PT.string, id: PT.string }),
  onChange: PT.func.isRequired,
};

ReportDropdown.defaultProps = { data: [], defaultValue: null };

export const Reports = ({ history, match }) => (
  <Auth forRoles="admin">
    <Nav>
      <div>
        <Grid padded columns="equal">
          <Grid.Row>
            <Grid.Column width={7}>
              <WithData url="/reports/available">
                <ReportDropdown
                  defaultValue={match && match.params && match.params.report}
                  onChange={(e, { value }) => history.push(`/reports/${value}`)}
                />
              </WithData>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button icon="refresh" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {match && match.params && match.params.report
          && <Report reportId={match.params.report} />
        }
      </div>
    </Nav>
  </Auth>
);

Reports.propTypes = {
  history: PT.shape({
    push: PT.func,
  }).isRequired,
  match: PT.shape({
    params: PT.shape({
      report: PT.string,
    }),
  }).isRequired,
};
